import state from '@/stores/folders/state.js'
import mutations from '@/stores/folders/mutations.js'
import actions from '@/stores/folders/actions.js'

export default {
  state,
  mutations,
  actions
}
